export interface PropsWithClessonId {
    clessonId: number;
}

export interface PropsWithCourseId {
    courseId: number | null;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getClessonIdFromProps = (storeState: any, ownProps: PropsWithClessonId): number | null => {
    if (ownProps && ownProps?.clessonId) {
        const themeId = Number(ownProps.clessonId);
        return Number.isNaN(themeId) ? null : themeId;
    }

    return null;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCourseIdFromProps = (storeState: any, ownProps: PropsWithCourseId): number | null => {
    if (ownProps && ownProps.courseId) {
        const courseId = Number(ownProps.courseId);
        return Number.isNaN(courseId) ? null : courseId;
    }

    return null;
};
